module.exports = __webpack_public_path__ + "img/UTS-Icon2.874703f6.png";